var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13225_64070)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.53445 2.17603C8.71439 2.17527 9.8778 2.44623 10.9264 2.96673C11.5666 3.28455 12.1528 3.68983 12.6672 4.1683C13.9946 2.9346 15.8057 2.17603 17.7981 2.17603C21.8529 2.17603 25.1665 5.32195 25.1665 9.23389C25.1665 12.6453 23.0759 15.7634 20.6387 18.1161C18.1891 20.4806 15.1955 22.2617 13.0079 22.9565C12.7861 23.027 12.5469 23.027 12.3251 22.9565C10.1375 22.2617 7.1439 20.4806 4.69435 18.1161C2.25706 15.7634 0.166504 12.6453 0.166504 9.23389C0.166504 5.3222 3.47972 2.17642 7.53416 2.17603M9.92682 4.85893C9.18896 4.49265 8.36871 4.30131 7.53569 4.30188L7.53492 4.30188C4.66208 4.30188 2.35949 6.52414 2.35949 9.23389C2.35949 11.8174 3.97507 14.4217 6.24173 16.6097C8.35799 18.6525 10.8742 20.1679 12.6665 20.8198C14.4588 20.1679 16.975 18.6525 19.0913 16.6097C21.3579 14.4217 22.9735 11.8174 22.9735 9.23389C22.9735 6.52414 20.6709 4.30188 17.7981 4.30188C16.0421 4.30188 14.4941 5.13397 13.5589 6.40385C13.353 6.6835 13.0203 6.8494 12.6658 6.84918C12.3114 6.84896 11.9789 6.68266 11.7733 6.40276C11.2976 5.75514 10.6646 5.22516 9.92682 4.85893Z",
    fill: "grey"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13225_64065",
    x1: -2.61562,
    y1: 8.92318,
    x2: 25.0989,
    y2: 19.7923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--gradient-start)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--gradient-end)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13225_64070"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(0.166504 0.0927734)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.41a1dbddbd74f482179a64ed2ebae7cf.svg";
export { ForwardRef as ReactComponent };